import React from 'react'
import { AccountContainer } from '../../AccountContainer'
import { ChatContainer } from './ChatContainer'
import { useChatMessageContext } from './Context'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  const { chatMessageResult } = useChatMessageContext()
  const subject = chatMessageResult?.document?.subject ?? ''
  return (
    <AccountContainer>
      <PageTitle
        title={subject || 'Message Details'}
        description={subject ? `Conversation about ${subject}` : 'View your conversation'}
      />
      <h4>{subject}</h4>
      <ChatContainer />
    </AccountContainer>
  )
}
